<div class="tile is-child box">
  <div class="content">
    <!-- Content -->
    <div class="logo">
      <!-- Logo -->
      <a href="/"><img src="../../../assets/images/theSlammHome.png" alt=""></a>
    </div>
  </div>
</div>
